import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeBE } from "../const";

export const CONVERTER_STUDY_TERMINOLOGY_CODE: {
  CONVERTER_STUDY_TERMINOLOGY_VALIDATION_REQUIRED_SHEET_EXISTS_RULE: MvnCodeBE;
  CONVERTER_STUDY_TERMINOLOGY_VALIDATION_REQUIRED_COLUMN_EXISTS_RULE: MvnCodeBE;
  CONVERTER_STUDY_TERMINOLOGY_VALIDATION_COLUMN_ORDINAL_MATCH_RULE: MvnCodeBE;
  CONVERTER_STUDY_TERMINOLOGY_VALIDATION_MINIMUM_ROW_COUNT_RULE: MvnCodeBE;
  CONVERTER_STUDY_TERMINOLOGY_VALIDATION_MAXIMUM_ROW_COUNT_RULE: MvnCodeBE;
} = {
  CONVERTER_STUDY_TERMINOLOGY_VALIDATION_REQUIRED_SHEET_EXISTS_RULE: {
    status: 400,
    ko: "유효하지 않은 파일 포맷입니다. 필수 시트 'My Dictionary'가 없습니다.",
    en: "Invalid file format. Required sheet 'My Dictionary' not found.",
  },
  CONVERTER_STUDY_TERMINOLOGY_VALIDATION_REQUIRED_COLUMN_EXISTS_RULE: {
    status: 400,
    ko: "필수 컬럼이 누락되었습니다. {value}",
    en: "Missing required columns. {value}",
  },
  CONVERTER_STUDY_TERMINOLOGY_VALIDATION_COLUMN_ORDINAL_MATCH_RULE: {
    status: 400,
    ko: "컬럼 순서가 템플릿과 일치하지 않습니다. Export로 받은 템플릿 파일을 사용해주세요.",
    en: "Column order does not match template. Please use the template file from export.",
  },
  CONVERTER_STUDY_TERMINOLOGY_VALIDATION_MINIMUM_ROW_COUNT_RULE: {
    status: 400,
    ko: "데이터가 없습니다. 최소 1개 이상의 데이터 행이 필요합니다.",
    en: "No data found. At least 1 data row is required.",
  },
  CONVERTER_STUDY_TERMINOLOGY_VALIDATION_MAXIMUM_ROW_COUNT_RULE: {
    status: 400,
    ko: "데이터 행이 너무 많습니다. 최대 10,000개까지 처리 가능합니다. (현재: {value}개)",
    en: "Too many data rows. Maximum 10,000 rows are allowed. (Current: {value} rows)",
  },
};

MvnCodeInitiate(CONVERTER_STUDY_TERMINOLOGY_CODE);
